import { axiosRequest, type AxiosResult } from "@/lib/axios";
import type { Partner } from "../types";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const partnerApi = {
	getBySlug: (slug: string): Promise<AxiosResult<Partner>> => {
		return axiosRequest({ url: `${API_BASE_URL}/partners/${slug}`, method: "GET" });
	},
};
